import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Training Partner Contracts")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-5 pb-0" }
const _hoisted_4 = { class: "row h-70px" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Partner", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_13 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_14 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_17 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#entity_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          placeholder: "Search",
          style: {"height":"1em"}
        })
      ])
    ])
  ])
], -1)
const _hoisted_19 = { class: "collapse show" }
const _hoisted_20 = { class: "card-body border-top p-6" }
const _hoisted_21 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-trash-alt" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "card"
}
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = { class: "col-md-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract Number", -1)
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract Name", -1)
const _hoisted_46 = { class: "row mt-3" }
const _hoisted_47 = { class: "col-md-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Sign Date", -1)
const _hoisted_49 = { class: "col-md-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Start Date", -1)
const _hoisted_51 = { class: "col-md-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "End Date", -1)
const _hoisted_53 = { class: "col-md-3" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Target")
], -1)
const _hoisted_55 = { class: "row mt-3" }
const _hoisted_56 = { class: "col-md-3" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Amount")
], -1)
const _hoisted_58 = { class: "col-md-3" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Contribution Percentage %")
], -1)
const _hoisted_60 = { class: "col-md-3" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Adjustable Advance Amount ")
], -1)
const _hoisted_62 = { class: "col-md-3" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Min Age")
], -1)
const _hoisted_64 = { class: "row mt-3" }
const _hoisted_65 = { class: "col-md-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Max Age")
], -1)
const _hoisted_67 = { class: "col-md-3" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Grace(M)")
], -1)
const _hoisted_69 = { class: "d-flex mt-5" }
const _hoisted_70 = ["data-kt-indicator"]
const _hoisted_71 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_72 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_73 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AssociationContractModal = _resolveComponent("AssociationContractModal")!
  const _component_AssociationContractModalView = _resolveComponent("AssociationContractModalView")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.batch.tranche_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
              options: _ctx.optionsTranche,
              mode: "tags",
              "clear-on-select": false,
              placeholder: "Select Tranche",
              "close-on-select": false,
              searchable: true,
              "create-option": true
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_ErrorMessage, {
              name: "entity_type_id",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.associationData,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.associationData) = $event)),
              options: _ctx.tempId,
              mode: "tags",
              "clear-on-select": false,
              placeholder: "Select Training Partner",
              "close-on-select": false,
              searchable: true,
              "create-option": true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getContactList())),
              type: "button",
              class: "btn btn-success mt-6 p-3",
              style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
            }, [
              _createTextVNode(" Search "),
              _hoisted_12
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", _hoisted_15, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 0 }]),
                "data-bs-toggle": "tab",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setActiveTab($event))),
                "data-tab-index": "0",
                href: "#contract_list",
                role: "tab"
              }, " Contract List ", 2)
            ]),
            (_ctx.entity_type == 1004)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 1 }]),
                    "data-bs-toggle": "tab",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setActiveTab($event))),
                    "data-tab-index": "1",
                    href: "#add_contract",
                    role: "tab"
                  }, " Add Contract ", 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    (_ctx.tabIndex === 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
          _hoisted_18,
          (_openBlock(), _createElementBlock("div", {
            key: _ctx.componentKey,
            id: "entity_data",
            class: "collapse show"
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_Datatable, {
                    "table-data": _ctx.tableData,
                    "table-header": _ctx.tableHeader,
                    "enable-items-per-page-dropdown": true
                  }, {
                    "cell-tranche": _withCtx(({ row: infos }) => [
                      _createTextVNode(_toDisplayString(infos.tranche.label), 1)
                    ]),
                    "cell-training_partner": _withCtx(({ row: infos }) => [
                      _createTextVNode(_toDisplayString(infos.entity?.entity_short_name), 1)
                    ]),
                    "cell-contract_number": _withCtx(({ row: infos }) => [
                      _createTextVNode(_toDisplayString(infos.contract_number), 1)
                    ]),
                    "cell-contract_name": _withCtx(({ row: infos }) => [
                      _createTextVNode(_toDisplayString(infos.contract_name), 1)
                    ]),
                    "cell-sign_date": _withCtx(({ row: infos }) => [
                      _createTextVNode(_toDisplayString(infos.sign_date
                    ? _ctx.moment(infos.sign_date).format('DD-MM-YYYY')
                    : ''), 1)
                    ]),
                    "cell-start": _withCtx(({ row: infos }) => [
                      _createTextVNode(_toDisplayString(infos.start ? _ctx.moment(infos.start).format('DD-MM-YYYY') : ''), 1)
                    ]),
                    "cell-end": _withCtx(({ row: infos }) => [
                      _createTextVNode(_toDisplayString(infos.end ? _ctx.moment(infos.end).format('DD-MM-YYYY') : ''), 1)
                    ]),
                    "cell-training_target": _withCtx(({ row: infos }) => [
                      _createTextVNode(_toDisplayString(_ctx.numberWithCommas(infos.target)), 1)
                    ]),
                    "cell-contract_amount": _withCtx(({ row: infos }) => [
                      _createTextVNode(_toDisplayString(_ctx.numberWithCommas(infos.amount)), 1)
                    ]),
                    "cell-attachment": _withCtx(({ row: infos }) => [
                      _createTextVNode(_toDisplayString(infos.attachment), 1)
                    ]),
                    "cell-actions": _withCtx(({ row: infos }) => [
                      _createElementVNode("button", {
                        "data-kt-drawer-toggle": "true",
                        "data-kt-drawer-target": "#kt_drawer_association_contract_view",
                        onClick: ($event: any) => (_ctx.view(infos)),
                        id: "kt_drawer_association_contract_view_button",
                        class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1"
                      }, _hoisted_24, 8, _hoisted_22),
                      _createElementVNode("button", {
                        "data-kt-drawer-toggle": "true",
                        "data-kt-drawer-target": "#kt_drawer_association_contract",
                        onClick: ($event: any) => (_ctx.edit(infos)),
                        id: "kt_drawer_association_contract_button",
                        class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                      }, _hoisted_27, 8, _hoisted_25),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.Delete(infos.id)),
                        class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                      }, _hoisted_30, 8, _hoisted_28)
                    ]),
                    _: 1
                  }, 8, ["table-data", "table-header"])
                ])
              ])
            ])
          ]))
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true),
    (_ctx.tabIndex === 1)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 1 }]),
                id: "add_contract"
              }, [
                _createVNode(_component_Form, {
                  onSubmit: _cache[20] || (_cache[20] = ($event: any) => (_ctx.formSubmit())),
                  class: "form"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _hoisted_38,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            "collapse-tags": "",
                            placeholder: "Select Tranche",
                            modelValue: _ctx.contract.tranche_id,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contract.tranche_id) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche, (trans) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: trans.id,
                                  label: trans.label,
                                  value: trans.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(trans.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "entity_type_id",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _hoisted_41,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Partner",
                            modelValue: _ctx.contract.entity_info_id,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contract.entity_info_id) = $event)),
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterEntity())),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: data.id,
                                  label: data.entity_short_name,
                                  value: data.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("[" + _toDisplayString(data.entity_short_name) + "]" + _toDisplayString(data.entity_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "contract_number",
                            class: "form-control form-control",
                            modelValue: _ctx.contract.contract_number,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contract.contract_number) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "contract_number",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createVNode(_component_Field, {
                            name: "contract_name",
                            class: "form-control form-control",
                            modelValue: _ctx.contract.contract_name,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contract.contract_name) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "contract_name",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _createVNode(_component_el_form_item, {
                            prop: "sign_date",
                            class: "mb-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                "value-format": "YYYY-MM-DD",
                                format: "DD-MM-YYYY",
                                style: {"width":"100%"},
                                type: "date",
                                name: "sign_date",
                                modelValue: _ctx.contract.sign_date,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contract.sign_date) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ErrorMessage, {
                            name: "sign_date",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createVNode(_component_el_form_item, {
                            prop: "",
                            class: "mb-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                "value-format": "YYYY-MM-DD",
                                format: "DD-MM-YYYY",
                                style: {"width":"100%"},
                                type: "date",
                                name: "start",
                                modelValue: _ctx.contract.start,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.contract.start) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ErrorMessage, {
                            name: "start",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createVNode(_component_el_form_item, {
                            prop: "end",
                            class: "mb-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                "value-format": "YYYY-MM-DD",
                                format: "DD-MM-YYYY",
                                type: "date",
                                style: {"width":"100%"},
                                name: "end",
                                modelValue: _ctx.contract.end,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.contract.end) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ErrorMessage, {
                            name: "end",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _createVNode(_component_Field, {
                            name: "target",
                            class: "form-control form-control",
                            modelValue: _ctx.contract.target,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.contract.target) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "target",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _createVNode(_component_Field, {
                            name: "amount",
                            class: "form-control form-control",
                            modelValue: _ctx.contract.amount,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.contract.amount) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "amount",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _hoisted_59,
                          _createVNode(_component_Field, {
                            name: "contribution_percentage",
                            class: "form-control form-control",
                            modelValue: _ctx.contract.contribution_percentage,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.contract.contribution_percentage) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "contribution_percentage",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createVNode(_component_Field, {
                            name: "adjustable_advance_amount\t",
                            class: "form-control form-control",
                            modelValue: _ctx.contract.adjustable_advance_amount,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.contract.adjustable_advance_amount) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "adjustable_advance_amount\t",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _hoisted_63,
                          _createVNode(_component_Field, {
                            name: "min_age",
                            class: "form-control form-control",
                            modelValue: _ctx.contract.min_age,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.contract.min_age) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "min_age",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createVNode(_component_Field, {
                            name: "max_age",
                            class: "form-control form-control",
                            modelValue: _ctx.contract.max_age,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.contract.max_age) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "max_age",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createVNode(_component_Field, {
                            name: "age_grace_in_month",
                            class: "form-control form-control",
                            modelValue: _ctx.contract.age_grace_in_month,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.contract.age_grace_in_month) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "age_grace_in_month",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            "data-kt-indicator": _ctx.loading ? 'on' : null,
                            class: "btn btn-lg btn-success",
                            type: "submit"
                          }, [
                            (!_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                                  _createTextVNode(" Submit "),
                                  _createElementVNode("span", _hoisted_72, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                                  _createTextVNode(" Please wait... "),
                                  _hoisted_74
                                ]))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_70)
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_AssociationContractModal),
    _createVNode(_component_AssociationContractModalView)
  ], 64))
}